import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ButtonBase from '@material-ui/core/ButtonBase';
import { withStyles } from '@material-ui/core/styles';

const RootContainer = styled.div`
  width: 100%;
`;

const ContentContainer = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 14px;
  color: #484848;
  height: auto;
  max-height: ${({ expand, collapseHeight }) => (
    expand ? 1000 : collapseHeight
  )}px;
  transition: max-height 200ms linear;
  position: relative;
  overflow: hidden;
`;

const ContentInnerContainer = styled.div`
  height: auto
`;

const GradientOverlay = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 40px;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.8),
    rgba(255, 255, 255, 1)
  );
  opacity: ${({ expand }) => (expand ? '0' : '1')};
  transition: opacity 250ms linear;
`;

const ShowMoreButton = withStyles(() => ({
  root: {
    fontSize: '16px',
    lineHeight: '16px',
    letterSpacing: '0.3px',
    color: '#5C8DF3',
    marginBottom: '24px',
  },
}))(ButtonBase);

const ExpansionContainer = ({ children, collapseHeight }) => {
  const [expand, setExpand] = useState(false);
  const [isLongContent, setIsLongContent] = useState(true);

  const onShowMoreClick = () => {
    setExpand(!expand);
  };

  const contentRef = React.createRef();

  useEffect(() => {
    if (contentRef.current) {
      setIsLongContent(contentRef.current.offsetHeight > collapseHeight);
    }
  }, [collapseHeight, contentRef]);

  return (
    <RootContainer>
      <ContentContainer expand={expand} collapseHeight={collapseHeight}>
        <ContentInnerContainer ref={contentRef}>
          {children}
        </ContentInnerContainer>
        {
          isLongContent && (
            <GradientOverlay expand={expand} />
          )
        }
      </ContentContainer>
      {
        isLongContent && (
          <ShowMoreButton onClick={onShowMoreClick}>
            {
              expand ? 'Show Less' : 'Show More'
            }
          </ShowMoreButton>
        )
      }
    </RootContainer>
  );
};

ExpansionContainer.propTypes = {
  children: PropTypes.node.isRequired,
  collapseHeight: PropTypes.number.isRequired,
};

export default ExpansionContainer;
